import '@/css/main.scss'
import { VudalPlugin } from 'vudal'
import Vue from 'vue'
import Vuex from 'vuex'
import App from '@/App'
import router from '@/router'
import userStore from '@/store'
import mainPlace from "@/components/place/MainPlace"
import topBar from "@/components/place/TopBar"
import leftMenu from "@/components/place/LeftMenu"
import searchInput from "@/components/utils/SearchInput"
import asyncSearchInput from "@/components/utils/AsyncSearchInput"
import editableItemPopup from "@/components/utils/EditableItemPopup"
import editableItemPricePopup from "@/components/utils/EditableItemPricePopup"
import productGroupPopup from "@/components/utils/ProductGroupPopup"
import vSelect from "vue-select"
import VueResource from "vue-resource"
import CommonPagination from "@/components/pagination/CommonPagination"
import scheduleStore from "@/components/schedule/ScheduleStore"
import VueTimepicker from 'vue2-timepicker'
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

Vue.component('common-pagination', CommonPagination)
Vue.component('v-select', vSelect)
Vue.component("top-bar", topBar)
Vue.component("left-menu", leftMenu)
Vue.component('main-place', mainPlace)
Vue.component('search-input', searchInput)
Vue.component('async-search-input', asyncSearchInput)
Vue.component('editable-item-popup', editableItemPopup)
Vue.component('editable-item-price-popup', editableItemPricePopup)
Vue.component('product-group-popup', productGroupPopup)
Vue.use(VueResource)
Vue.use(VueTimepicker)
Vue.use(VudalPlugin)
Vue.config.productionTip = false

Vue.prototype.$eventHub = new Vue();

const store = new Vuex.Store({
  modules: {
    scheduleStore: scheduleStore,
    userStore: userStore
  }
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js